import React, { useState } from 'react';
import Panel from '../../components/ui/Panel';
import Button from '../../components/ui/Button';
import Dialog from '../../components/ui/Dialog';

const DialogsPage: React.FC = () => {
  const [alertOpen, setAlertOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [choice, setChoice] = useState('No choice yet.');

  return (
    <div>
      <h1 id="overview" className="text-3xl text-osrs-gold font-bold uppercase mb-4">Dialogs</h1>
      <p className="text-osrs-yellow mb-8">
        Alerts, confirmations, and modal windows share one stone frame. The difference is the title colour and the buttons in the body.
      </p>

      <section id="alerts" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Alerts</h2>
        <Panel>
          <Button variant="danger" onClick={() => setAlertOpen(true)}>Show alert</Button>
          <Dialog open={alertOpen} variant="alert" title="Inventory full" onClose={() => setAlertOpen(false)}>
            <p className="mb-4">You do not have enough inventory space.</p>
            <Button onClick={() => setAlertOpen(false)}>OK</Button>
          </Dialog>
        </Panel>
      </section>

      <section id="confirmations" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Confirmations</h2>
        <Panel>
          <Button variant="secondary" onClick={() => setConfirmOpen(true)}>Destroy item</Button>
          <p className="text-osrs-yellow mt-4">{choice}</p>
          <Dialog open={confirmOpen} variant="confirm" title="Destroy rune scimitar?" onClose={() => setConfirmOpen(false)}>
            <p className="mb-4">This cannot be undone.</p>
            <div className="flex gap-2">
              <Button onClick={() => { setChoice('Destroyed.'); setConfirmOpen(false); }}>Yes</Button>
              <Button variant="secondary" onClick={() => { setChoice('Kept.'); setConfirmOpen(false); }}>No</Button>
            </div>
          </Dialog>
        </Panel>
      </section>

      <section id="modal-dialogs" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Modal Dialogs</h2>
        <Panel>
          <Button onClick={() => setModalOpen(true)}>Talk to Hans</Button>
          <Dialog open={modalOpen} variant="dialogue" title="Hans" onClose={() => setModalOpen(false)}>
            <p className="mb-4">I have been waiting here for 20 years.</p>
            <Button onClick={() => setModalOpen(false)}>Click here to continue</Button>
          </Dialog>
        </Panel>
      </section>

      <section id="usage-guidelines" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Usage Guidelines</h2>
        <Panel>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2 ml-4">
            <li>Use an alert when the player can only acknowledge the message.</li>
            <li>Use a confirmation when the action destroys something.</li>
            <li>Use dialogue for a single NPC line on the tan surface.</li>
          </ul>
        </Panel>
      </section>
    </div>
  );
};

export default DialogsPage;
